var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tour-item"},[_c('div',{staticClass:"tour-item__bg"}),_vm._v(" "),_c('section',{staticClass:"grid grid--container"},[_c('div',{staticClass:"row row--lg-center row--md-h-center"},[_c('div',{class:`col ${_vm.contentCol}`},[_c('div',{class:`tour-item__content ${
            _vm.right ? 'tour-item__content--right' : ''
          }`},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{class:`col ${_vm.mediaCol} ${
          _vm.right ? 'col--lg-first' : ''
        } text--xs-center`},[_vm._t("media")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }